export default {
    success: 'Success',
    critical: 'Critical',
    void: 'Void',
    future: 'Future',
    pickedUp: 'PickedUp',
    reflight: 'Reflight',
};
